import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTabData } from "../../redux/programs/ProgramsAction";

import CONSTANTS from "../../utils/constants/CONSTANTS";
import CustomButton from "../../components/CustomButton";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const Workout = ({ workoutImg, monthlyPrice, learnMoreTab, workoutName }) => {
  const onSignUp = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
    eventTrack("Redirection To Web Portal", "From sign up button in workouts section", "Redirection");
    eventTrackGA4("Redirection To Web Portal", "From sign up button in workouts section", "Redirection");
  };
  const dispatch = useDispatch();
  const handleTab = () => {
    dispatch(setTabData(learnMoreTab));
    window.scrollTo(0, 0);
  };

  return (
    <div className="workout">
      <div className="img-details">
        <div className="workout-image">
          <img className="image" src={workoutImg} alt="workout-img" />
        </div>
        <div className="details">
          <div className="prices">
            <div className="starting">Starting From:</div>
            <div className="monthly">{monthlyPrice}</div>
          </div>
          <div className="btns">
            <div className="sign-up">
              <CustomButton type={CONSTANTS.ROUNDED_TYPE} handleClick={onSignUp}>
                Sign Up
              </CustomButton>
            </div>
            <div className="learn-btn">
              <Link className="learn-more" to="/programs" onClick={handleTab}>
                Learn More
              </Link>
            </div>
          </div>
        </div>
        <div className="workout-name">{workoutName}</div>
      </div>
    </div>
  );
};
export default Workout;
